export default __webpack_public_path__ + "static/media/FSMeridian-Medium.7cf13bfd.woff2";